import { PropsWithChildren, useMemo } from 'react'

import colors from 'src/styles/theme/colors'

import { BackgroundPattern, HeroBackground, HeroUnifiedMode } from '../types'

export type HeroRebrandLayoutProps = PropsWithChildren<
  {
    unified?: boolean
    mode?: HeroUnifiedMode
    darkHeader?: boolean
    // Image layout only: dark gradient over the photo (keeps white dark-mode
    // text legible). Defaults to true so existing heroes are unchanged; set
    // false for light-mode heroes where the image shouldn't be dimmed.
    imageOverlay?: boolean
  } & HeroBackground
>

const patternImageMap: { [key in BackgroundPattern]: string } = {
  patternLavenderSoft: 'heroLavenderSoft',
  patternLimeBright: 'heroLimeBright',
  patternPeach: 'heroPeach',
  patternGreenMarble: 'heroGreenMarble'
}

export const HeroRebrandLayout = ({
  children,
  unified = false,
  mode,
  layout,
  color,
  imageUrl,
  pattern,
  darkHeader = false,
  imageOverlay = true
}: HeroRebrandLayoutProps) => {
  const backgroundClasses = useMemo(() => {
    let className = ''
    switch (layout) {
      case 'image':
        className = 'bg-no-repeat bg-cover bg-center min-h-140 '
        break
      case 'solid':
        className = ``
        break
      default:
        className = `bg-no-repeat bg-cover ${patternImageMap[pattern]}`
        break
    }
    return className
  }, [pattern, layout])

  return (
    <div
      className={`${
        mode === 'light' ? 'hero-rebrand-light' : 'hero-rebrand-dark'
      } ${unified ? 'unified' : ''} ${
        darkHeader ? 'dark-header' : ''
      } ${backgroundClasses}`}
      style={{
        ...(layout === 'image' && {
          backgroundImage: imageOverlay
            ? `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),url("${imageUrl}")`
            : `url("${imageUrl}")`
        }),
        ...(layout === 'solid' && {
          backgroundColor: colors[color]
        })
      }}
    >
      <div className='mx-auto w-full max-w-(--content-max-width) justify-center items-center'>
        {children}
      </div>
    </div>
  )
}
